import { render, staticRenderFns } from "./PropertyListSales.vue?vue&type=template&id=6e023c0c&scoped=true"
import script from "./PropertyListSales.vue?vue&type=script&lang=js"
export * from "./PropertyListSales.vue?vue&type=script&lang=js"
import style0 from "./PropertyListSales.vue?vue&type=style&index=0&id=6e023c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e023c0c",
  null
  
)

export default component.exports